import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';



@Injectable({ providedIn: 'root' })
export class LegalService {

  private configUrl = 'https://hsccdn.blob.core.windows.net/devcdn/legallink.json';
  private privacyUrl$?: Observable<string>;

  constructor(private http: HttpClient) {}

  getPrivacyUrl(): Observable<string> {

    if (!this.privacyUrl$) {
      this.privacyUrl$ = this.http
        .get<{ privacyUrl: string }>(this.configUrl)
        .pipe(
          map(data => data.privacyUrl),
          shareReplay(1) // caches the result
        );
    }

    return this.privacyUrl$;
  }
}
